import React from "react";
import ReactDOM from "react-dom";
import "antd/dist/antd.css";
import { Provider } from "react-redux";
import { Router } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { history, store } from "./helpers";
import { setInitialLanguage } from "./helpers/locales";
import { InterceptorService } from "./services/interceptor";
import { setPusherClient } from "react-pusher";
import Pusher from "pusher-js";
import { Integrations } from "@sentry/tracing";
import App from "./App";
// import "bootstrap/dist/css/bootstrap.css";
import "./css/theme/index.css";
// all the custom style other than theme will go here
import "./css/custom.css";
import "./css/user_prompt.css";

if (navigator.userAgent.toLowerCase().indexOf("firefox") > -1) {
  document.body.classList.add("firefox");
}
window.store = store;
// localization code
// initialize languages
setInitialLanguage();
InterceptorService(store);
// initialize google analytics

if (process.env.REACT_APP_ENVIRONMENT === "production") {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN_URL,
    tracesSampleRate: 1.0,
    environment: process.env.REACT_APP_ENVIRONMENT,
    integrations: [new Integrations.BrowserTracing()]
  });
}

// setup pusher
const pusherClient = new Pusher(process.env.REACT_APP_PUSHER_KEY);
setPusherClient(pusherClient);

ReactDOM.render(
  // <MixpanelProvider mixpanel={mixpanel}>
  <Provider store={store}>
    <Router history={history}>
      <App />
    </Router>
  </Provider>,
  // </MixpanelProvider>,
  document.getElementById("root")
);
